import React, { useRef } from 'react';
import './chapters.scss';
import Float from '../Float/Float';

function Chapter1() {
  const float1Ref = useRef();

  return (
    <div className="chapters__chapter">
      <p className="chapters__chapter__paragraph">
        Depression is one of the most common mental illnesses in America and yet the conversations
        that surround it are often whispered due to stigma.<sup>1</sup> The absence of these
        conversations contrasts with the more than 22 million American adults who had at least one
        major depressive episode in 2022, a daunting statistic.<sup>2</sup> But the truth is,
        clinical depression (major depressive disorder) can affect us all. It does not discriminate
        and can affect anyone no matter their age, gender, race, or socioeconomic class.
      </p>
      <p className="chapters__chapter__paragraph">
        Beyond the stigma, there are a number of factors that may prevent people from receiving care
        and effective treatment, including barriers to healthcare that can make it difficult for
        many people to seek the guidance of medical professionals. Others continue to encounter
        obstacles, and their depression symptoms persist even after professional help and receiving
        initial treatment. When someone has tried two or more oral antidepressants of adequate dose
        and duration without relief, this is often referred to as treatment-resistant depression, or
        TRD.<sup>3</sup>
      </p>
      <div className="chapters__chapter__float">
        <Float index={0} floatRef={float1Ref} />
        <p className="chapters__chapter__paragraph">
          Nearly a third of people living with depression may have TRD.<sup>3</sup> Those who are
          diagnosed with this more severe form of depression can cycle through several treatments
          with no relief, sometimes for decades. That’s why it’s so important to share the stories
          of real people with challenging-to-treat forms of depression who found the support they
          needed and relief from their depressive symptoms.
        </p>
        <p className="chapters__chapter__paragraph chapters__chapter__paragraph--d">
          What follows are the stories of three people from different backgrounds and across the
          country who have all struggled with challenging-to-treat depression (in their own lives or
          with a loved one) and are now, with their symptoms under control, living their lives on
          their own terms. These are the stories of:
        </p>
      </div>
      <p className="chapters__chapter__paragraph chapters__chapter__paragraph--m">
        What follows are the stories of three people from different backgrounds and across the
        country, who have all struggled with challenging-to-treat depression (in their own lives or
        with a loved one) and are now, with their symptoms under control, living their lives on
        their own terms. These are the stories of:
      </p>
    </div>
  );
}

export default Chapter1;
